import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; 
import HomePage from "./HomePage";
import Testpage from "./pages/Testpage";
import NewsPage from "./pages/NewsPage";
import NewsPost from "./pages/NewsPost";
import Header from "./components/Header";
import GamesPage from "./pages/GamesPage";
import GamesPost from "./pages/GamesPost";


// ✅ Add this
import ScrollToHashElement from "./ScrollToHashElement";

function App() {
  return (
    <Router> {/* ✅ Entire app must be inside Router */}
      <Header />
      <ScrollToHashElement /> {/* ✅ Add this to allow scrolling on hash change */}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/test" element={<Testpage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:slugOrId" element={<NewsPost />} />
        <Route path="/news/:documentId" element={<NewsPost />} />   {/* optional */}
        <Route path="/games/:slugOrId" element={<GamesPost />} />
        <Route path="/games/:documentId" element={<GamesPost />} />
        <Route path="/games" element={<GamesPage />} />
        

      </Routes>
    </Router>
  );
}

export default App;
